import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  box: {
    width: '520px',
    margin: 'auto',
    padding: '0 15px',
    borderRadius: 5,
    backgroundColor: props => props.backgroundColor,
  },
  icon: {
    maxWidth: '100%',
    height: 'auto',
    width: 24,
  },
  message: {
    margin: 0,
    padding: 15,
    fontSize: 13,
    color: theme.palette.common.white,
    width: 400,
  },
}));
